import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/sweetalert2'
import './plugins/simple-alert-vue'
import './plugins/notification-vue'
import './plugins/scroll-to-vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import axios from 'axios';
import OctoberApi from "vue-october-requests";

Vue.use(OctoberApi, { axios });


Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
